import { Component } from "../component"
import anime from "animejs"

export class SectionMakerCollection extends Component {
  constructor(props) {
    super(props)
  }

  ui() {
    return {
      select: ".page-navigation-select",
    }
  }

  attachEvents() {
    const { select } = this.$ui

    select.addEventListener("change", () => {
      const section = document.getElementById(select.value)
      if (section) {
        const position = section.offsetTop - 50
        anime({
          targets: [document.documentElement, document.body],
          scrollTop: position,
          duration: 900,
          easing: "easeInOutQuart",
        })
      }
    })
  }

  created() {
    if (window.innerWidth < 768) {
      this.attachEvents()
    }
  }
}
